export const cleanDuplicates = (items: any, idItem: string | string[]): any[] => {
  const finalIdValues = typeof idItem === 'string'
                        ? [idItem]
                        : idItem
  const finalItems = items.reduce((ac: any, current: any) => {
    let id = '';
    for (let i = 0; i < finalIdValues.length; i++) {
      id += `${current[finalIdValues[i]]}`
    } 
    if (!ac[id]) {
      ac[id] = current;
    }
    return ac;
  }, {});

  return Object.values(finalItems);
}